import React from "react";
import { Link } from "react-router-dom";
import KnightLogo from "../components/site/KnightLogo";

export default function LegalPage({ title, children }) {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-black/5">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <KnightLogo className="h-9 w-auto" tone="dark" />
          </Link>
          <Link to="/" className="text-sm text-slate-600 hover:text-[#011233] transition-colors">
            ← Back to site
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 sm:px-8 py-16">
        <h1 className="text-4xl sm:text-5xl font-light tracking-tight text-slate-900">
          {title}
        </h1>
        <div className="mt-10 prose prose-slate max-w-none text-slate-700 leading-relaxed space-y-5">
          {children}
        </div>
      </main>
    </div>
  );
}
